export const VIDEO_CONTAINER_MIN_WIDTH = 290;
export const VIDEO_CONTAINER_MAX_WIDTH = 350;
export const GAP = 24;
export const SKELETON_COUNT = 7;
export const ONE_COLUMN_BREAKPOINT = 928;
export const GRID_PADDING_COUNT = 20;
export const GET_CURRENT_SUBSCRIPTION_KEY = 'get-current-subscription';

export const GET_PROJECTS_KEY = 'GET_PROJECTS_KEY';
